import React from "react";

import ApplyButton from "../applyButton";

const CtaButton = (props) => {
  /** NOTES:
   * primary - apply now
   * secondary - compare
   * **/

  const buttonPresets = Object.freeze({
    base: {
      buttonStyle: `group relative flex flex-row items-center justify-center px-2 py-2 rounded-full border 
      hover:shadow-sm dark:rounded-sm
      ${props?.extraButtonStyle}`,
      labelClass: `${props?.labelClass || ""}`,
      arrowClass: `${props?.arrowClass || ""} `
    },
    primary: {
      buttonStyle: `group relative flex flex-row items-center justify-center px-2 py-2 rounded-full border
      bg-red-light text-white border-red-light 
      hover:bg-white hover:border-black-lighter hover:text-black-lighter hover:shadow-sm
      dark:rounded-sm dark:text-gray-darker dark:bg-green-standard
      dark:hover:bg-gray-darker dark:hover:text-green-standard dark:border-green-standard`,
      labelClass: `${props?.labelClass || ""}`,
      arrowClass: `stroke-white group-hover:stroke-black-lighter 
      dark:group-hover:stroke-green-standard dark:hover:stroke-green-standard dark:stroke-gray-darker 
      ${props?.arrowClass || ""} `
    },
    secondary: {
      buttonStyle: `group relative flex flex-row items-center justify-center px-4 py-2 rounded-full text-black-lighter border-black-lighter border 
      hover:bg-black-lighter hover:border-black-lighter hover:text-white hover:shadow-sm
      dark:rounded-sm dark:text-white dark:border-white dark:bg-gray-darker
      dark:hover:bg-white dark:hover:text-gray-darker `,
      labelClass: `${props?.labelClass || ""}`,
      arrowClass: `stroke-black-lighter hover:stroke-white group-hover:stroke-white
      dark:stroke-white dark:hover:stroke-gray-darker dark:group-hover:stroke-gray-darker 
      ${props?.arrowClass || ""} `
    },
    tertiary: {
      buttonStyle: `group relative flex flex-row items-center justify-center px-2 py-2 rounded-full bg-white text-black-lighter border-black-lighter border 
      hover:bg-black-lighter hover:border-black-lighter hover:text-white hover:shadow-sm
      dark:rounded-sm dark:text-white dark:border-white dark:bg-darker
      dark:hover:bg-white dark:hover:text-gray-darker `,
      labelClass: `${props?.labelClass || ""}`,
      arrowClass: `stroke-black-lighter hover:stroke-white group-hover:stroke-white
      dark:stroke-white dark:hover:stroke-gray-darker dark:group-hover:stroke-gray-darker 
      ${props?.arrowClass || ""} `
    },
    quaternary: {
      buttonStyle: `group relative flex flex-row items-center justify-center px-2 py-2 rounded-full bg-red-light text-white border-red-light border 
      hover:bg-white hover:border-black-lighter hover:text-black-lighter hover:shadow-sm
      dark:rounded-sm dark:text-gray-darker dark:bg-green-standard dark:hover:bg-white dark:bg-green-standard 
      dark:hover:bg-gray-darker dark:hover:text-green-standard dark:border-green-standard`,
      labelClass: `${props?.labelClass || ""}`,
      arrowClass: `stroke-white group-hover:stroke-black-lighter 
      dark:group-hover:stroke-green-standard dark:hover:stroke-green-standard dark:stroke-gray-darker 
      ${props?.arrowClass || ""} `
    },
    quinary: {
      buttonStyle: `group relative flex flex-row items-center justify-center px-4 py-2 rounded-full bg-white text-black-lighter border-black-lighter border 
      hover:bg-black-lighter hover:border-black-lighter hover:text-white hover:shadow-sm
      dark:rounded-sm dark:text-gray-darker dark:border-gray-darker dark:bg-white
      dark:hover:bg-gray-darker  dark:hover:text-white `,
      labelClass: `${props?.labelClass || ""}`,
      arrowClass: `stroke-black-lighter hover:stroke-white group-hover:stroke-white
      dark:stroke-white dark:hover:stroke-gray-darker dark:group-hover:stroke-gray-darker 
      ${props?.arrowClass || ""} `
    },
    senary: {
      buttonStyle: `group relative flex flex-row items-center justify-center px-2 py-2 rounded-full bg-white text-black-lighter border-black-lighter border
      dark:rounded-sm dark:text-white dark:border-white dark:bg-darker`,
      labelClass: `${props?.labelClass || ""}`,
      arrowClass: `stroke-black-lighter
      dark:stroke-white 
      ${props?.arrowClass || ""} `
    }
  });

  const { preset } = props;

  return (
    <>
      {preset ? (
        <ApplyButton {...props} {...buttonPresets[preset]} />
      ) : (
        <ApplyButton {...props} />
      )}
    </>
  );
};

export default CtaButton;
CtaButton.defaultProps = {
  labelClass: "text-base leading-genericCta font-bold pr-2"
};
